exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n:host body {\n  -webkit-text-size-adjust: none;\n  -ms-text-size-adjust: none;\n  margin: 0;\n  padding: 0; }\n:host table {\n  border-spacing: 0;\n  table-layout: fixed;\n  margin: 0 auto; }\n:host table table table {\n  table-layout: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/content/app/br/br.component.scss
// module id = ../../../../../src/app/main/content/app/br/br.component.scss
// module chunks = main